var utils = {}
utils.extends = function(anyUtils) {
    for (var k in anyUtils)
        utils[k] = anyUtils[k]
}
utils.Group = function(strArr, fn) {
    var groups = {};
    if (fn == undefined)
        fn = function(item) {
            return item;
        }
    strArr.map(function(item) {
        var key = fn(item); // item.substr(1,1);
        var arr = groups[key];
        if (arr === undefined) {
            groups[key] = [];
            arr = groups[key];
        }
        arr.push(item);
    });
    return groups;
}
utils.PropertyToArray = function(obj) {
        var result = [];
        for (var key in obj) {
            var s = {};
            s["key"] = key;
            s["value"] = obj[key];
            result.push(s);
        }
        return result;
    }
utils.each = function (arr, fn) {
    for (var i = 0; i < arr.length; i++) {
        fn(arr[i], i);
    }
}

export default utils


// WEBPACK FOOTER //
// ./src/utils/objectUtils.js